import { parseDate } from "../utilities/parseHelper";
import { DateType } from "./types/index";

/**
 * Класс данных операции счёта.
 */
export class AccountStatementOperationData {
  /**
   * Дата списания со счёта.
   */
  public RegDate: string = '';

  /**
   * Дата совершения операции.
   */
  public CommitDate: string = '';

  /**
   * Сумма списания со счёта.
   */
  public Sum: number = 0;

  /**
   * Описание к операции счёта.
   */
  public Description: string = "";

  /**
   * Ссылка на операцию из каталога
   */
  public CatalogId: number = 0;

  public IsSbp: boolean = false;

  /**
   * Референс счёта.
   */
  public Reference: string = "";

  /**
   * Наименование категории.
   */
  public MCCName: string = "";

  /**
   * Цвет категории.
   */
  public MCCColor: string = "";

  public Status: number = 0;

  /**
   * Картинка категории
   */
  public MCCImageUrl: string = "";

  public Details: any = null;

  /**
   * Конструктор с загрузкой данных с сервера.
   * @param src Источник данных.
   */
  constructor(src: any = null, details: any = null) {
    if (src) {
      this.RegDate = src.RegDate ?? "";
      this.CommitDate = src.CommitDate ?? "";
      this.Sum = src.Sum ?? 0;
      this.Description = src.Description ?? "";
      this.Reference = src.Reference ?? "";
      this.MCCName = src.MCCName ?? "";
      this.IsSbp = src.IsSbp ?? false;
      this.CatalogId = src.CatalogId ?? null;
      this.MCCColor = src.MCCColor ?? "";
      this.MCCImageUrl = (src.MCCImageUrl || src.Picture) ?? "";
      this.Status = src.Status ?? 0;
      this.Details = details;
    }
  }
}
